import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

// ENABLE IF SCRIPT
//dotenv.config();

export const env = createEnv({
  /**
   * Specify your server-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars.
   */
  server: {
    DATABASE_ENV: z.string(),
    AUTH_DB_URL: z.string(),
    //CACHE_URL: z.string(),
    JWT_SECRET: z.string(),
    MAILSERVER_FROM: z.string(),
    PATREON_REDIRECT_BASE: z.string().url(),
    PATREON_CLIENT_ID: z.string(),
    PATREON_CLIENT_SECRET: z.string(),
    DISCORD_APP_ID: z.string(),
    DISCORD_TOKEN: z.string(),
    DISCORD_PUBLIC_KEY: z.string(),
    R2_ACCESS_KEY_ID: z.string(),
    R2_SECRET_ACCESS_KEY: z.string(),
    R2_ACCOUNT_ID: z.string(),
    MAILCHIMP_API_KEY: z.string(),
    HTML2PDF_API_KEY: z.string(),
    RANGER_ADMIN_EMAIL: z.string(),
    CACHE_URL: z.string().optional(),
    TEST_EMAIL: z.string().optional(),
    OTEL_ENDPOINT: z.string().optional(),
    OTEL_KEY: z.string().optional(),
    OTEL_ENABLED: z.boolean().optional(),
    PDF_USE_PUPPETEER: z.boolean().optional()
  },

  /**
   * Specify your client-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars. To expose them to the client, prefix them with
   * `NEXT_PUBLIC_`.
   */
  client: {
    NEXT_PUBLIC_LOBBY_URL: z.string().url(),
    NEXT_PUBLIC_AF_URL: z.string().url(),
    NEXT_PUBLIC_ENV: z.string(),
    NEXT_PUBLIC_ENABLE_RANGERS: z.boolean(),
    NEXT_PUBLIC_R2_DOMAIN: z.string().url(),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().url(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
    NEXT_PUBLIC_ENABLED_FEATURES: z.string().optional()
  },

  /**
   * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
   * middlewares) or client-side so we need to destruct manually.
   */
  runtimeEnv: {
    // Server-side variables
    DATABASE_ENV: process.env.DATABASE_ENV,
    AUTH_DB_URL: process.env.AUTH_DB_URL,
    CACHE_URL: process.env.CACHE_URL,
    JWT_SECRET: process.env.JWT_SECRET,
    MAILSERVER_FROM: process.env.MAILSERVER_FROM,
    PATREON_REDIRECT_BASE: process.env.PATREON_REDIRECT_BASE,
    PATREON_CLIENT_ID: process.env.PATREON_CLIENT_ID,
    PATREON_CLIENT_SECRET: process.env.PATREON_CLIENT_SECRET,
    DISCORD_APP_ID: process.env.DISCORD_APP_ID,
    DISCORD_TOKEN: process.env.DISCORD_TOKEN,
    DISCORD_PUBLIC_KEY: process.env.DISCORD_PUBLIC_KEY,
    R2_ACCESS_KEY_ID: process.env.R2_ACCESS_KEY_ID,
    R2_SECRET_ACCESS_KEY: process.env.R2_SECRET_ACCESS_KEY,
    R2_ACCOUNT_ID: process.env.R2_ACCOUNT_ID,
    MAILCHIMP_API_KEY: process.env.MAILCHIMP_API_KEY,
    HTML2PDF_API_KEY: process.env.HTML2PDF_API_KEY,
    RANGER_ADMIN_EMAIL: process.env.RANGER_ADMIN_EMAIL,
    TEST_EMAIL: process.env.TEST_EMAIL,
    OTEL_ENDPOINT: process.env.OTEL_ENDPOINT,
    OTEL_KEY: process.env.OTEL_KEY,
    OTEL_ENABLED: process.env.OTEL_ENABLED === "true",
    PDF_USE_PUPPETEER: process.env.PDF_USE_PUPPETEER === "true",

    // Client-side variables
    NEXT_PUBLIC_LOBBY_URL: process.env.NEXT_PUBLIC_LOBBY_URL,
    NEXT_PUBLIC_AF_URL: process.env.NEXT_PUBLIC_AF_URL,
    NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
    NEXT_PUBLIC_ENABLE_RANGERS: process.env.NEXT_PUBLIC_ENABLE_RANGERS === "true",
    NEXT_PUBLIC_R2_DOMAIN: process.env.NEXT_PUBLIC_R2_DOMAIN,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_ENABLED_FEATURES: process.env.NEXT_PUBLIC_ENABLED_FEATURES
  },

  /**
   * For Next.js >= 13.4.4, you only need to destructure client variables
   * if you're using the experimental appDir.
   * @see https://github.com/t3-oss/t3-env#nextjs-1344
   */
  skipValidation: process.env.VALIDATE_ENV !== "true",
  emptyStringAsUndefined: true
});

export const isFeatureEnabled = (feature: string) => {
  const features =
    env.NEXT_PUBLIC_ENABLED_FEATURES?.split(",").map((x) => x.toLowerCase().trim()) ?? ([] as string[]);
  return features.includes(feature.toLowerCase());
};
